import type { JiraSpaRoute, RouterContext } from '@atlassian/react-resource-router';
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';
import {
	MENU_ID_FOR_YOU,
	MENU_ID_TEAMS,
	MENU_ID_PROJECTS,
	MENU_ID_PROJECTS_VIEW_ALL,
} from '../../../../constants.tsx';
import type { SelectedPath } from '../../../../types.tsx';

const routes = new Set<RouteName>(['for-you', 'people-index']);

function convert(routeContext: RouterContext<JiraSpaRoute>): SelectedPath {
	const routeName = routeContext.route.name;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertNew(args: { routeName: RouteName }): SelectedPath {
	const { routeName } = args;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertRouteToPath(args: { routeName: RouteName; path: string[] }): SelectedPath {
	const { routeName, path } = args;
	switch (routeName) {
		case 'for-you':
			path.push(MENU_ID_FOR_YOU);
			path.push(MENU_ID_PROJECTS);
			path.push(MENU_ID_PROJECTS_VIEW_ALL);
			break;
		case 'people-index':
			path.push(MENU_ID_TEAMS);
			break;
		default:
	}

	return path;
}

export const topLevelConverter: {
	routes: Set<RouteName>;
	convert: typeof convert;
	convertNew: typeof convertNew;
} = { routes, convert, convertNew };
